import http from '@root/utils/axios/admin';

let state = {
    RandomQuestion: {},
    CheckAnswer: {}
}

let actions = {

    fetchRandomQuestion({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('subscriber/random-question', data).then((response) => {
                commit('setRandomQuestion', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    checkAnswer({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('subscriber/check-answer', data).then((response) => {
                commit('setCheckAnswer', response.data);
                resolve(response);
            }).catch((error) => {
                reject(error.response);
            })
        });

    },

}


let mutations = {
    setRandomQuestion(state, data) {
        state.RandomQuestion = data;
    },
    setCheckAnswer(state, data) {
        state.CheckAnswer = data;
    },

}

export default {
    state,
    actions,
    mutations
}